import Config from 'app/config';

export default (endpoint = 'login', redirectPath = '') => {
  const accountHost = Config.get('ACCOUNT_HOST');
  const signUrl = `${window.location.origin}/sign`;
  const redirectUrl = `${window.location.origin}/${redirectPath}`;

  return `${accountHost}/${endpoint}?signUrl=${signUrl}&url=${redirectUrl}`;
};
